import { useMedia } from './useMedia';

export const usePrefersDarkMode = () =>
  useMedia<boolean>(['(prefers-color-scheme: dark)'], [true], false);
